export const RECONNECT_QUIET_MS = 2000;

/**
 * Exponential backoff for pending browser sign-in WebSocket only (not the main bridge).
 */
export const PENDING_AUTH_RECONNECT_FIRST_MS = 100;
export const PENDING_AUTH_RECONNECT_MAX_MS = 30_000;

export function pendingAuthReconnectDelayMs(attemptBeforeIncrement: number): number {
  return Math.min(PENDING_AUTH_RECONNECT_FIRST_MS * 2 ** attemptBeforeIncrement, PENDING_AUTH_RECONNECT_MAX_MS);
}
